/**
 * Renders article bodies that are written in Markdown.
 *
 * The guide blogs keep their text as Markdown, either in the article's
 * `custom.markdown` metafield or inside a `.markdown-content` div in the
 * article body itself. Both arrive here as the element's text; marked turns
 * them into HTML once the page has parsed. The element stays hidden until
 * this has run so nobody sees a wall of asterisks and hashes.
 */
(() => {
  const wrapTables = (root) => {
    root.querySelectorAll('table').forEach((table) => {
      if (table.parentNode.classList.contains('scrollable-table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'scrollable-table';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  };

  // A handful of guides write formulas as $$ ... $$. MathJax is only fetched
  // for those, and only after the Markdown has become HTML, so its own
  // startup pass finds the finished page.
  const loadMathJax = () => {
    if (document.getElementById('mathjax-script')) return;
    window.MathJax = { tex: { inlineMath: [['$', '$'], ['\\(', '\\)']] } };
    const script = document.createElement('script');
    script.id = 'mathjax-script';
    script.async = true;
    script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js';
    document.head.appendChild(script);
  };

  const render = () => {
    let needsMathJax = false;
    document.querySelectorAll('.markdown-content').forEach((block) => {
      try {
        if (window.marked) {
          const markdown = block.textContent;
          needsMathJax = needsMathJax || /\$\$|\\\(/.test(markdown);
          block.innerHTML = window.marked.parse(markdown);
          wrapTables(block);
        }
      } catch (error) {
        console.error('Markdown rendering failed:', error);
      }
      // Reveal either way — raw Markdown beats a blank page.
      block.classList.add('markdown-content--rendered');
    });
    if (needsMathJax) loadMathJax();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
